import styled from "styled-components";

export const SelectorContainer = styled.div`
  padding: 1rem;
  background-color: ${(props) => props.theme.colors.GREY_1};
  font-size: 3.2rem;
  text-align: center;
  p {
    color: ${(props) => props.theme.colors.SELECTED};
  }
`;

export const MonthSelectorModalContainer = styled.div`
  background-color: ${(props) => props.theme.colors.WHITE};
  width: 60rem;
  min-height: 60rem;
  border-radius: 2rem;
  box-sizing: border-box;

  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 4rem;

  .item {
    width: 30%;
    height: 20%;
    background-color: ${(props) => props.theme.colors.GREY_1};
    font-size: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &.selected {
      border: 0.25rem solid ${(props) => props.theme.colors.SELECTED};
      color: ${(props) => props.theme.colors.SELECTED};
    }
    &.disabled {
      color: ${(props) => props.theme.colors.TEXT_GREY};
      background-color: ${(props) => props.theme.colors.GREY_2};
    }

    span {
      font-size: 2rem;
    }
  }
`;
